export default __webpack_public_path__ + "static/media/slide3.38baab84.jpg";